import React, {Component} from 'react'
import SignupForm from '../../components/SignupForm'

export default class Propinfo extends Component {
  state = {
    open: false,
  }

  toggleModal = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    return (
      <div className="py-20 th-home--mobiletop">
        <div className="container grid-xl pt-20 text-center" style={{marginBottom: '4rem'}}>
          <div className="container grid-xl text-center">
            <p className="h1 th-home--mobilefonth1" style={{marginTop: '1rem', color: '#000000'}}>
              <i className="far fa-check-circle" style={{color: '#4ABF62'}} /> &nbsp;Monitor Buyer Activity.
            </p>
            <p className="h4 th-home--mobilefonth4" style={{color: '#00414b', marginBottom: '2em'}}>
              Understand true buyer interest in fewer steps with buyer interest reports.
            </p>
          </div>

          <div className="columns ">
            <div className="column container grid-sm">
              <a className="btn btn-block" style={{border: '0px #cdcdcd solid'}} onClick={this.toggleModal}>
                <i className="fas fa-video fa-md" style={{color: '#00a6d4'}} /> &nbsp; LEARN MORE
              </a>
              {this.state.open && (
                <div className="modal active" id="share-mod">
                  <a className="modal-overlay" aria-label="Close" onClick={this.toggleModal} />
                  <div className="modal-container " role="document">
                    <div className="modal-header">
                      <a className="btn btn-clear float-right" aria-label="Close" onClick={this.toggleModal} />
                      <div className="modal-title text-primary text-left text-dark">See offers coming with diligence & activity monitoring.</div>
                    </div>
                    <div className="modal-body bg-primary">
                      <div className="video-responsive video-responsive-4-3" style={{color: '#00414b', marginTop: '-2rem', marginBottom: '-3rem'}}>
                        <iframe
                          width="640"
                          height="360"
                          src="https://player.vimeo.com/video/315969757?autoplay=0&title=0&byline=0&portrait=0"
                          title="Activity Demo"
                        />
                      </div>
                    </div>
                    <div className="modal-footer ">
                      <SignupForm size="md" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
